export enum AuthIcons {
    personalAccount = 'PERSONAL_ACCOUNT',
    companyAccount = 'COMPANY_ACCOUNT',
}
export enum RecipientIcons {
    recipientUser = 'RECIPIENT_USER',
    recipientDocument = 'RECIPIENT_DOCUMENT',
    recipientCalendar = 'RECIPIENT_CALENDAR',
    recipientPhone = 'RECIPIENT_PHONE',
    recipientHouse = 'RECIPIENT_HOUSE',
    recipientTaxDocument = 'RECIPIENT_TAX_DOCUMENT',
    recipientImage = 'RECIPIENT_IMAGE',
    recipientEdit = 'RECIPIENT_EDIT',
    recipientMain = 'RECIPIENT_MAIN',
}
export enum ViewIcons {
    list = 'VIEW_BY_LIST',
    card = 'VIEW_BY_CARD',
}
export enum OrderIcons {
    noOrders = 'NO_ORDERS',
    removeProduct = 'REMOVE_PRODUCT', // TODO: check if needed
    moveProduct = 'MOVE_PRODUCT',
    success = 'ORDER_SUCCESS',
    homeDeliveryGreenBox = 'HOME_DELIVERY_GREEN_BOX',
    homeDeliveryBlueBox = 'HOME_DELIVERY_BLUE_BOX',
    hasPrintedLabel = 'HAS_PRINTED_LABEL',
    paymentSuccessful = 'PAYMENT_SUCCESSFUL',

    homeDelivery = 'HOME_DELIVERY',
    warehouseDelivery = 'WAREHOUSE_DELIVERY',

    productsTableRemove = 'PRODUCTS_TABLE_REMOVE',
    productsTableTransfer = 'PRODUCTS_TABLE_TRANSFER',
    productsTableNew = 'PRODUCTS_TABLE_NEW',

    scanOrder = 'SCAN_ORDER',
    scanOrderGreen = 'SCAN_ORDER_GREEN',
    markAsReadyForShipment = 'MARK_AS_READY_FOR_SHIPMENT',
    locate = 'LOCATE',
    changeStatuses = 'CHANGE_STATUSES',
    markAsSent = 'MARK_AS_SENT',
    addToGroup = 'ADD_TO_GROUP',
    printLabel = 'PRINT_LABEL',
    history = 'history',
}

export enum AttachmentIcons {
    upload = 'ATTACHMENT_UPLOAD',
    download = 'ATTACHMENT_DOWNLOAD',

    pdf = 'ATTACHMENT_PDF',
    doc = 'ATTACHMENT_DOC',
    image = 'ATTACHMENT_IMG',
}

export enum AdditionalServiceIcons {
    takeAPhoto = "TAKE_A_PHOTO",
    onHold = "KEEP_ON_HOLD",
    takeAPhotoFromInside = "TAKE_A_PHOTO_FROM_INSTIDE",
    check = "CHECK",
    divide = "DIVIDE",
    repack = "repack",
}

export enum UserIcons {
    noPaymentMethod = 'NO_PAYMENT_METHOD'
}
